// style dependencies
import '../../modal/style';
